<template>
        <div class="relative">
                <input
                        :value="modelValue"
                        :type="revealed ? 'text' : 'password'"
                        autocomplete="off"
                        class="w-full py-2.5 px-3 pr-10 border border-gray-300 rounded-lg text-sm outline-none box-border font-mono"
                        @input="onInput"
                >
                <button
                        type="button"
                        class="absolute right-2 top-1/2 -translate-y-1/2 p-1 bg-transparent border-none cursor-pointer text-gray-400 hover:text-gray-600"
                        :title="revealed ? 'Hide' : 'Reveal'"
                        @click="revealed = !revealed"
                >
                        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path v-if="!revealed" stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                <path v-else stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                        </svg>
                </button>
        </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
        name: 'SecretInput',
        props: {
                modelValue: {
                        type: String,
                        default: '',
                },
        },
        emits: ['update:modelValue'],
        setup(_, { emit }) {
                const revealed = ref(false);

                const onInput = (event: Event): void => {
                        emit('update:modelValue', (event.target as HTMLInputElement).value);
                };

                return { revealed, onInput };
        },
});
</script>
